import { Link } from "react-router";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { EASE, VIEW } from "../bits";
import { EVENT } from "./event";
import "./Candle.css";

/* Variant E: the card version of the candlelit event bar above the nav, so
   the two read as one event. Near-black with a warm glow from below, the
   candlelit poster glowing at the edges, and the shimmering gold ticket. */

const STARS = [[58, 12], [72, 22], [88, 9], [94, 30], [64, 34], [81, 40]];

export function EventCandle() {
  return <motion.div className="evc-wrap" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={VIEW} transition={{ duration: 0.7, ease: EASE }}>
    <Link to={EVENT.href} className="evc">
      <span className="evc-glow" aria-hidden="true" />
      {STARS.map(([x, y], i) => <i key={i} className="evc-star" style={{ left: `${x}%`, top: `${y}%`, animationDelay: `${i * 0.7}s` }} aria-hidden="true" />)}
      <span className="evc-poster"><img src={EVENT.poster} alt={EVENT.posterAlt} width={1080} height={1350} /></span>
      <span className="evc-body">
        <small className="evc-kicker">{EVENT.kicker}</small>
        <b className="evc-title">{EVENT.headline[0]} <i>{EVENT.film}</i> {EVENT.headline[1]}</b>
        <span className="evc-rule" aria-hidden="true" />
        <span className="evc-info">
          <span className="evc-name">{EVENT.title}</span>
          <span>{EVENT.weekday}, {EVENT.month} {EVENT.day} · {EVENT.time}</span>
          <span>{EVENT.venue}</span>
        </span>
        <span className="evc-cta">Get tickets · {EVENT.price} <ArrowRight size={16} aria-hidden="true" /></span>
      </span>
    </Link>
  </motion.div>;
}
